import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";

import { PlusIcon } from "../../Icons";
import { SubmitButton } from "../Button/SubmitButton";
import { NextSubmitButton } from "../EmptyPageState/EmptyPageState";

interface MainPageStateProps {
  title: string;
  addButtonText?: string;

  shouldShowHeader?: boolean;
  isDialogOpen: boolean;
  isShouldShowEmptyState: boolean;

  onAddButtonClick?: () => void;

  DialogComp: any;
  DrawerComp: any;
  EmptyStateComp: any;

  children: any;
  hiddenElement?: () => string | undefined;
}

export const MainPage = ({
  hiddenElement,
  title,
  addButtonText,
  isDialogOpen,
  isShouldShowEmptyState,
  onAddButtonClick,
  DialogComp,
  DrawerComp,
  EmptyStateComp,
  children,
  shouldShowHeader = true,
}: MainPageStateProps) => {
  return (
    <Box
      sx={{
        height: "calc(100vh - 82px)",
        overflow: "auto"
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          padding: "32px 36px 0 32px",
          position: "relative",
          minWidth: "535px"
        }}
      >
        {isDialogOpen ? DialogComp : null}

        <Box>
          {DrawerComp}
        </Box>

        {
          shouldShowHeader ? (
            <Box
              display="flex"
              flexDirection="row"
              flex={1}
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography component="h1" variant="h1">
                {title}
              </Typography>
              <Box>
                {!isShouldShowEmptyState ? (
                  <>
                    <SubmitButton
                      sx={{
                        display: hiddenElement,
                      }}
                      title={addButtonText}
                      endIcon={<PlusIcon />}
                      onClick={onAddButtonClick}
                    />
                  </>
                ) : null}
              </Box>
            </Box>
          ) : null
        }
        {isShouldShowEmptyState ? EmptyStateComp : children}
      </Box>
    </Box>
  );
};

